import { Button, Space } from 'antd';
import { Spin } from 'antd';
import { Flex } from 'antd/lib';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MEDIA_QUERIES } from 'src/enums';
import useWindowDimensions from 'src/hooks/useWindowDimensions';
import { useTheme } from 'src/styles/theme';
import { IDocument } from 'src/types/documents.types';
import { formatDate } from 'src/utils/dates';

import classes from './style/DocumentCard.module.css';

interface IDocumentCardProps {
  exa?: string;
  doc: IDocument;
  downloadDocument: (doc: IDocument) => Promise<void>;
}

const DocumentCard: React.FunctionComponent<IDocumentCardProps> = ({
  doc,
  downloadDocument
}) => {
  // TOOLS
  const theme = useTheme();
  const { t } = useTranslation();
  const { width } = useWindowDimensions() || { height: 0, width: 0 };
  const [loading, setLoading] = useState(false);

  const handleDownload = async (doc: IDocument) => {
    setLoading(true);
    try {
      await downloadDocument(doc);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex vertical justify="center" align="center" className={classes.line}>
      <Flex justify="space-between" className={classes.documentContainer}>
        <Flex justify="flex-end">
          <Space size="small">
            <p className={`${theme.fonts.classNames.cardSubtitle}`}>
              {formatDate(doc.docDate)}
            </p>
            <p className={`${theme.fonts.classNames.cardTitle}`}>
              {width && width >= MEDIA_QUERIES.TABLET
                ? doc.docName
                : doc.wardDesc}
            </p>
            {width && width >= MEDIA_QUERIES.TABLET && (
              <p className={`${theme.fonts.classNames.cardSubtitle}`}>
                {doc.wardDesc}
              </p>
            )}
          </Space>
        </Flex>
        <Flex justify="flex-start">
          {doc?.isNew && (
            <Flex className={classes.badge} align="center">
              <span>{t('common.new')}</span>
            </Flex>
          )}
          <Button
            className={classes.downloadButton}
            onClick={() => handleDownload(doc)}
          >
            {loading ? (
              <Spin />
            ) : (
              <img
                src="/assets/icons/downloadPdf.png"
                alt="Download PDF"
                className={classes.downloadIcon}
              />
            )}
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DocumentCard;
